export default "__VITE_ASSET__9f439b35__"